import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import NextNewsletterApi from '@features/api/nextApiService/nextNewsletterApi';
class NewsletterStore {
  email = '';
  errorMessage = '';
  inputActive = false;
  showThx = false;
  termsAgreement = false;
  sendingProgress = false;
  agreementValidate = true;
  constructor() {
    makeAutoObservable(this, {
      email: observable,
      inputActive: observable,
      agreementValidate: observable,
      submitNewsletterForm: action,
      setErrorMessage: action,
      setShowThx: action,
      setTermsAgreement: action,
      setInputActive: action
    });
  }
  public setEmail = (val: string) => {
    this.email = val;
  };
  public setInputActive = (val: boolean) => {
    this.inputActive = val;
  };
  public setErrorMessage = (val: string) => {
    this.errorMessage = val;
  };
  public setShowThx = (val: boolean) => {
    this.showThx = val;
  };
  public setTermsAgreement = (val: boolean) => {
    this.termsAgreement = val;
    this.agreementValidate = val;
  };
  public submitNewsletterForm = async (): Promise<void> => {
    this.email = this.email.trim();
    this.agreementValidate = this.termsAgreement;
    if (this.emailValidation() && this.termsAgreement) {
      this.sendingProgress = true;
      const response = await NextNewsletterApi.newsletterSend(this.email, 'footer');
      const {
        status
      } = response;
      runInAction(() => {
        this.sendingProgress = false;
        if (status !== '200') {
          this.setErrorMessage('footer.newsletter.submitError');
        }
        this.setShowThx(true);
      });
    }
  };
  private emailValidation = (): boolean => {
    this.setErrorMessage('');
    const pattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (pattern.test(this.email)) return true;
    this.setErrorMessage(!this.email.length ? 'footer.newsletter.inputEmailEmpty' : 'footer.newsletter.inputEmailValid');
    return false;
  };
}
export default NewsletterStore;